import { render, staticRenderFns } from "./forbiddenRequest.vue?vue&type=template&id=48904d20&scoped=true"
import script from "./forbiddenRequest.vue?vue&type=script&lang=js"
export * from "./forbiddenRequest.vue?vue&type=script&lang=js"
import style0 from "./forbiddenRequest.vue?vue&type=style&index=0&id=48904d20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48904d20",
  null
  
)

export default component.exports